import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import PanelContext from '../../sidebar/panel/panelContext';
import ArticleActions from '../../articleActions/articleActions';
import SavePdfAnchor from '../../articleActions/actionTypes/savePdfAnchor';
import ViewPdfAnchor from '../../articleActions/actionTypes/viewPdfAnchor';
import { PiiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function PiiArticlePreviewActions({
  pii, pdfPath, viewPdfEventData, savePdfEventData, onComponentClick,
}) {
  const { getId } = useContext(PanelContext);
  const id = `view-button-pii-${pii}-${getId()}`;
  return (
    <ArticleActions>
      <ViewPdfAnchor
        id={id}
        pii={pii}
        viewPdfEventData={viewPdfEventData}
        onClick={onComponentClick}
      />
      {pdfPath && (
        <SavePdfAnchor
          pdfPath={pdfPath}
          savePdfEventData={savePdfEventData}
          onClick={onComponentClick}
        />
      )}
    </ArticleActions>
  );
}

PiiArticlePreviewActions.propTypes = {
  viewPdfEventData: PiiArticleEventsPropTypes.viewPdf,
  savePdfEventData: PiiArticleEventsPropTypes.savePdf,
  pii: PropTypes.string.isRequired,
  pdfPath: PropTypes.string,
  onComponentClick: PropTypes.func,
};

PiiArticlePreviewActions.defaultProps = {
  viewPdfEventData: undefined,
  savePdfEventData: undefined,
  pdfPath: undefined,
  onComponentClick: undefined,
};
